import React from 'react';
import { Lock, Zap, ShieldCheck, HeadphonesIcon } from 'lucide-react';
export function TrustMicrosection() {
  const items = [{
    icon: <Lock size={24} data-id="element-267" />,
    title: 'SSL Seguro',
    desc: 'Tu pago está protegido con encriptación de 256 bits'
  }, {
    icon: <Zap size={24} data-id="element-268" />,
    title: 'Acceso Inmediato',
    desc: 'Recibes todo en tu correo en segundos'
  }, {
    icon: <ShieldCheck size={24} data-id="element-269" />,
    title: 'Garantía 30 Días',
    desc: 'Si no ves resultados, te devolvemos el dinero'
  }, {
    icon: <HeadphonesIcon size={24} data-id="element-270" />,
    title: 'Soporte Real',
    desc: 'Equipo disponible para ayudarte'
  }];
  return <section className="py-12 px-4 bg-white border-b border-sage/20" data-id="element-271">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-272">
        {items.map((item, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-273">
            <div className="text-relief mb-3" data-id="element-274">{item.icon}</div>
            <h4 className="font-heading font-bold text-teal text-sm mb-1" data-id="element-275">
              {item.title}
            </h4>
            <p className="text-xs text-neutral-gray font-sans" data-id="element-276">{item.desc}</p>
          </div>)}
      </div>
    </section>;
}